// Account: the facts that belong to the person rather than to either side of what they
// do on the platform. Identity, how they pay, where they are signed in, what they have
// been given, and which experiments they are in.
//
// Two columns rather than one stack, and sections rather than accordions — the record
// idiom the Driver tab already used, now carried across the whole page. Identity is the
// tallest card and the one you came for, so it heads the left column; the two list
// sections (cards, sessions) pack down the right.
//
// Devices sits under Sessions, which is where the prototype put it and for its reason: a
// session is a login you can revoke, a device is the hardware and its push state. The
// endpoint the prototype flagged as missing now exists (hitch-services #3451), reading the
// `Device` table that #3313 added.
import React from 'react';
import { TabGrid } from './parts';
import { useHasPermission } from '../../helpers/api/auth/index';

import UserDetailsCard from '../../components/widgets/Users/UserDetailsCard';
import PaymentSourcesCard from '../../components/widgets/Users/PaymentSourcesCard';
import SessionsCard from '../../components/widgets/Users/SessionsCard';
import UserDevicesCard from '../../components/widgets/Users/UserDevicesCard';
import PromotionsCard from '../../components/widgets/Users/PromotionsCard';
import ReferralsCard from '../../components/widgets/Users/ReferralsCard';
import ExperimentsCard from '../../components/widgets/Users/ExperimentsCard';
import RawDataCard from '../../components/shared/RawDataCard';
import ErrorBoundary from '../../components/shared/ErrorBoundary';

const AccountTab = ({ user, userRawUnsafe, growthbook }) => {
  const hasRawDataPermission = useHasPermission('raw_data');

  return (
    <TabGrid
      left={
        <>
          {/* Identity is where the editable fields live: name / email / phone through
              UserEditDialog behind `edit_user`. That behaviour is the card's own —
              kept, not reimplemented. */}
          <UserDetailsCard user={user} />
          <PromotionsCard user={user} />
          <ErrorBoundary label="ReferralsCard" message="Referrals couldn't be loaded for this user.">
            <ReferralsCard user={user} />
          </ErrorBoundary>
        </>
      }
      right={
        <>
          <PaymentSourcesCard user={user} />
          <SessionsCard user={user} />
          <UserDevicesCard user={user} />
          {/* The card evaluates every GrowthBook feature at mount; a bad flag payload
              used to take the page down with it, which is what its old render-level
              try/catch was standing in for. A boundary is the version that actually
              catches. */}
          <ErrorBoundary label="ExperimentsCard" message="Experiments couldn't be loaded for this user.">
            <ExperimentsCard user={user} growthbook={growthbook} />
          </ErrorBoundary>
          {/* Last, and collapsed: it is the debugging escape hatch, not a fact about
              the person. */}
          {hasRawDataPermission && <RawDataCard title="Raw data" jsonObject={userRawUnsafe} />}
        </>
      }
    />
  );
};

export default AccountTab;
